import { render, staticRenderFns } from "./proof-view-events-panel.vue?vue&type=template&id=27fb6fd8&"
import script from "./proof-view-events-panel.vue?vue&type=script&lang=js&"
export * from "./proof-view-events-panel.vue?vue&type=script&lang=js&"
import style0 from "./proof-view-events-panel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports